import { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Row, Col, Typography, Button } from 'antd';
import IntlMessages from "../../../components/utility/intlMessages";
import { DvIntlMessages } from '../../../components/utility/dvGeneralUtilities';
import ClinicEditModal from './clinicEditModal';

const { Title } = Typography;

function ClinicDetailsGeneral(props) {
  const [isClinicEditFormOpen, setIsClinicEditFormOpen] = useState(false);

  return (
    <Row style={{marginTop: '25px'}}>
      <Col span={24}>
        <Title level={1}>
          {props.data.summaryData?.title}
        </Title>
        {props.data.summaryData?.isEnterpriseProduct && <Title level={3}>
          <IntlMessages id="general.enterpriseProduct" />
        </Title>}

        {props.data.summaryData?.oncoEmailAddress && <div>
          {props.data.summaryData?.oncoEmailAddress}
        </div>}
        <div>
        {props.data.summaryData?.uniqueId}
        </div>
        <div>
          <IntlMessages id="clinicPage.clinicDetails.numOfPatients" />: {props.data.summaryData?.numberOfPatients}
        </div>
        <div>
          <IntlMessages id="clinicPage.clinicDetails.numOfUsers" />: {props.data.summaryData?.users.length}
        </div>
        <div>
          <IntlMessages id="clinicPage.clinicDetails.totalFilesSize" />: {props.data.summaryData?.totalFilesSize}
        </div>
        <div>
          <IntlMessages id="clinicPage.clinicDetails.numberOfRegularlFiles" />: {props.data.summaryData?.numberOfRegularlFiles}
        </div>
        <div>
          <IntlMessages id="clinicPage.clinicDetails.numberOfDicomFiles" />: {props.data.summaryData?.numberOfDicomFiles}
        </div>
        <div>
          <a href={process.env.REACT_APP_S3_VIEWER_URL} target="_blank" rel="noopener noreferrer">
            <IntlMessages id="clinicPage.clinicDetails.s3Bucket" />
          </a>
          <Button type='link' onClick={() => setIsClinicEditFormOpen(true)}>
            {DvIntlMessages('clinicPage.clinicDetails.editClinic')}
          </Button>
        </div>
      </Col>

      {props.data.clinicId &&
        <ClinicEditModal
          clinicId={props.data.clinicId}
          isClinicEditFormOpen={isClinicEditFormOpen}
          closeClinicEditForm={() => setIsClinicEditFormOpen(false)}
        />}
    </Row>
  )
}

ClinicDetailsGeneral.propTypes = {
  data: PropTypes.object.isRequired,
};

ClinicDetailsGeneral.defaultProps = {
  data: {}
}

const mapActionsToProps = {
};

function mapStateToProps(state) {
  return {
    data: state.SystemInfos.get('clinicDetails'),
  };
}

const connectedClinicDetailsGeneral = connect(mapStateToProps, mapActionsToProps)(ClinicDetailsGeneral);
export default connectedClinicDetailsGeneral;